export default "__VITE_ASSET__BV2zjwQW__"